(function() {
  var STATUS_STYLES = {
    preorder: {
      icon: '📅',
      background: '#fff4e5',
      border: '#f0b429'
    },
    custom_order: {
      icon: '⏳',
      background: '#eef3ff',
      border: '#5b7fd6'
    }
  };

  var CONTACT_URL = '/pages/contact';
  var CUSTOM_CTA_ID = 'variant-availability-custom-cta';

  function isColorLabel(text) {
    return (text || '').trim().toLowerCase().indexOf('color') === 0;
  }

  function getColorFieldset() {
    var variantSelects = document.querySelector('variant-selects, variant-radios');
    if (!variantSelects) return null;
    var fieldsets = variantSelects.querySelectorAll('fieldset');
    for (var i = 0; i < fieldsets.length; i++) {
      var legend = fieldsets[i].querySelector('legend');
      if (legend && isColorLabel(legend.textContent)) return fieldsets[i];
    }
    return null;
  }

  function getColorDropdownWrapper() {
    var variantSelects = document.querySelector('variant-selects, variant-radios');
    if (!variantSelects) return null;
    var wrappers = variantSelects.querySelectorAll('.product-form__input--dropdown');
    for (var i = 0; i < wrappers.length; i++) {
      var label = wrappers[i].querySelector('label');
      if (label && isColorLabel(label.textContent)) return wrappers[i];
    }
    return null;
  }

  function getSelectedColor() {
    var colorFieldset = getColorFieldset();
    if (colorFieldset) {
      var colorInput = colorFieldset.querySelector('input[type="radio"]:checked');
      if (colorInput) return colorInput.value;
    }
    var dropdownWrapper = getColorDropdownWrapper();
    if (dropdownWrapper) {
      var select = dropdownWrapper.querySelector('select');
      if (select) return select.value;
    }
    return null;
  }

  function getDataScript() {
    var scripts = document.querySelectorAll('script[data-variant-availability]');
    return scripts.length ? scripts[scripts.length - 1] : null;
  }

  function renderBanner(container, entry) {
    if (!entry || !entry.status || !STATUS_STYLES[entry.status]) {
      container.innerHTML = '';
      container.style.display = 'none';
      return;
    }
    var style = STATUS_STYLES[entry.status];
    container.style.display = 'flex';
    container.style.alignItems = 'flex-start';
    container.style.gap = '10px';
    container.style.background = style.background;
    container.style.border = '1px solid ' + style.border;
    container.style.borderRadius = '8px';
    container.style.padding = '12px 16px';
    container.style.margin = '12px 0 28px';
    container.innerHTML =
      '<span style="font-size:1.3rem;line-height:1.2;">' + style.icon + '</span>' +
      '<span style="font-size:0.95rem;line-height:1.4;">' + entry.message + '</span>';
  }

  function toggleBuyButtonsForCustomOrder(isCustomOrder) {
    var buttonWrappers = document.querySelectorAll('.product-form__buttons');
    for (var i = 0; i < buttonWrappers.length; i++) {
      var wrapper = buttonWrappers[i];
      if (!wrapper.parentNode) continue;

      wrapper.style.display = isCustomOrder ? 'none' : '';

      var cta = wrapper.parentNode.querySelector('#' + CUSTOM_CTA_ID);
      if (isCustomOrder) {
        if (!cta) {
          cta = document.createElement('a');
          cta.id = CUSTOM_CTA_ID;
          cta.href = CONTACT_URL;
          cta.className = 'button button--full-width button--primary';
          cta.textContent = 'Request a Custom Quote';
          wrapper.parentNode.insertBefore(cta, wrapper.nextSibling);
        }
      } else if (cta) {
        cta.parentNode.removeChild(cta);
      }
    }
  }

  var lastRenderedKey = null;

  function updateBanner() {
    var dataScript = getDataScript();
    var container = document.querySelector('[data-variant-availability-banner]');
    if (!dataScript || !container) return;
    var map;
    try {
      map = JSON.parse(dataScript.textContent);
    } catch (e) {
      return;
    }
    var color = getSelectedColor();
    var key = color ? color.toLowerCase().trim() : null;
    var entry = key ? map[key] : null;
    var renderKey = (key || '') + '|' + (entry ? '1' : '0') + '|' + (container.innerHTML.length > 0 ? '1' : '0');
    if (renderKey === lastRenderedKey) return;
    lastRenderedKey = renderKey;
    renderBanner(container, entry);
    toggleBuyButtonsForCustomOrder(!!(entry && entry.status === 'custom_order'));
  }

  function init() {
    updateBanner();

    // Hardening: Dawn re-renders product-info sections after variant changes,
    // which can wipe or orphan the banner between our event handlers.
    // A cheap poll guarantees the banner always matches the selected variant
    // within ~0.5s regardless of listener races or section morphs.
    setInterval(updateBanner, 500);

    if (window.subscribe && window.PUB_SUB_EVENTS) {
      subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, function(event) {
        var target = event && event.data && event.data.target;
        if (target) {
          var fieldset = target.closest('fieldset');
          var legend = fieldset ? fieldset.querySelector('legend') : null;
          if (legend && !isColorLabel(legend.textContent)) return;
        }
        updateBanner();
      });
    }

    document.addEventListener('click', function(e) {
      var label = e.target.closest('label');
      if (!label) return;
      var input = document.getElementById(label.htmlFor);
      if (!input || input.type !== 'radio') return;
      var fieldset = input.closest('fieldset');
      var legend = fieldset ? fieldset.querySelector('legend') : null;
      if (!legend || !isColorLabel(legend.textContent)) return;
      updateBanner();
    });

    document.addEventListener('change', function(e) {
      if (e.target.tagName !== 'SELECT') return;
      var wrapper = e.target.closest('.product-form__input--dropdown');
      var label = wrapper ? wrapper.querySelector('label') : null;
      if (!label || !isColorLabel(label.textContent)) return;
      updateBanner();
    });
  }

  function waitForPubSub(attempts) {
    if (attempts <= 0) {
      init();
      return;
    }
    if (window.subscribe && window.PUB_SUB_EVENTS) {
      init();
    } else {
      setTimeout(function() { waitForPubSub(attempts - 1); }, 100);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { waitForPubSub(20); });
  } else {
    waitForPubSub(20);
  }
})();
